var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPessoas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 4.99997C10.9166 4.99997 11.6666 5.74997 11.6666 6.66664C11.6666 7.58331 10.9166 8.33331 9.99998 8.33331C9.08331 8.33331 8.33331 7.58331 8.33331 6.66664C8.33331 5.74997 9.08331 4.99997 9.99998 4.99997ZM9.99998 12.5C12.25 12.5 14.8333 13.575 15 14.1667V15H4.99998V14.175C5.16665 13.575 7.74998 12.5 9.99998 12.5ZM9.99998 3.33331C8.15831 3.33331 6.66665 4.82497 6.66665 6.66664C6.66665 8.50831 8.15831 9.99997 9.99998 9.99997C11.8416 9.99997 13.3333 8.50831 13.3333 6.66664C13.3333 4.82497 11.8416 3.33331 9.99998 3.33331ZM9.99998 10.8333C7.77498 10.8333 3.33331 11.95 3.33331 14.1667V16.6667H16.6666V14.1667C16.6666 11.95 12.225 10.8333 9.99998 10.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPessoas);
export default __webpack_public_path__ + "static/media/Pessoas.ff69292b916a023f14dd709a7f9d8ef7.svg";
export { ForwardRef as ReactComponent };